import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageTypeLookupComponent } from './page-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PageTypeLookupComponent],
  exports:[PageTypeLookupComponent]
})
export class PageTypeLookupModule { }
